// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'

export default function SearchResultAction (props) {
  return (
    <div className='search-result-action'>
      {props.children}
      <i className='fas fa-chevron-right' />
    </div>
  )
}

SearchResultAction.propTypes = {
  children: PropTypes.node
}

SearchResultAction.defaultProps = {
  children: null
}
